export default __webpack_public_path__ + "static/media/andrzejewski.56fa76b3.mp4";